export const buildNumber = '20260803.2';
export const version = '3.14.2';
export const latestCommit = '1dc303099fe01850e1025eaa5ac91429bc144653';
